<template>
  <div class="rootDiv">
    <br>
    <Span class="title">计算间隔</Span>
    <br>
    <br>
    <div>
      <div style="float:left">
        <Field label="开始时间" placeholder="请选择开始时间" type="date" v-model="startDate"></Field>
      </div>
      <div style="float:left">
        <div style="float:left;margin-top: 0.3rem">
          <mt-switch v-model="interval_startDateType"></mt-switch>
        </div>
        <div style="float:left;margin-top: 0.5rem;margin-left: 0.5rem">
          <span v-if="interval_startDateType">农历</span>
          <span v-else>公历</span>
        </div>
      </div>
      <div style="float:left">
        <Field label="结束时间" placeholder="请选择结束时间" type="date" v-model="endDate"></Field>
      </div>
      <div style="float:left">
        <div style="float:left;margin-top: 0.3rem">
          <mt-switch v-model="interval_endDateType"></mt-switch>
        </div>
        <div style="float:left;margin-top: 0.5rem;margin-left: 0.5rem">
          <span v-if="interval_endDateType">农历</span>
          <span v-else>公历</span>
        </div>
      </div>
      <Button size="large" type="default" style="background-color: #2986de" v-on:click.native="CalculationInterval">
        计 算
      </Button>
    </div>
    <br>
    <Span class="title">计算日期</Span>
    <br>
    <br>
    <div style="float:left">
      <Field label="开始时间" placeholder="请选择开始时间" type="date" v-model="tempDate"></Field>
    </div>
    <div style="float:left">
      <div style="float:left;margin-top: 0.3rem">
        <mt-switch v-model="date_startDateType"></mt-switch>
      </div>
      <div style="float:left;margin-top: 0.5rem;margin-left: 0.5rem">
        <span v-if="date_startDateType">农历</span>
        <span v-else>公历</span>
      </div>
    </div>
    <div style="clear: both"></div>
    <Field label="选择条件" placeholder="请选择条件" :readonly="true" type="username" v-model="selectedCondition"
           v-on:click.native="PickerControl"></Field>
    <Field label="条件数值" placeholder="请输入条件值" type="number" v-model="selectedValue"
           :attr="{ oninput: 'if(value.length>8)value=value.slice(0,8)' }"></Field>
    <Button size="large" type="default" style="background-color: #2986de" v-on:click.native="CalculationDate">计 算
    </Button>
    <Popup class="popupClass"
           v-model="fxPopupVisible"
           position="bottom">
      <div>
        <div class="buttondiv1"><span @click="PickerControl">取消</span></div>
        <div class="buttondiv2"><span @click="PickerControl">确定</span></div>
      </div>
      <div class="line"></div>
      <div class="pickerdiv">
        <Picker :slots="slots" @change="onValuesChange"></Picker>
      </div>
    </Popup>
  </div>
</template>

<script>
import {Field, Button, Picker, Popup} from "mint-ui";
import {formatDate} from "@/js/DateUtils";

export default {
  name: "DateTool",
  components: {
    Field, Button, Picker, Popup
  },
  data() {
    return {
      interval_startDateType: null,
      interval_endDateType: null,
      date_startDateType: null,
      slots: [
        {
          flex: 1,
          values: ['往后', '往前'],
          className: 'slot1',
          textAlign: 'center',
          defaultIndex: 0,
        }, {
          divider: true,
          content: '-',
          className: 'slot2'
        }, {
          flex: 1,
          values: ['天', '星期', '月'],
          className: 'slot3',
          textAlign: 'center',
          defaultIndex: 0,
        }
      ],
      fxPopupVisible: false,
      selectedValue: 0,
      selectedCondition: null,
      calculatedateUrl: '/api/otherapi/calculatedate',
      calculationintervalUrl: '/api/otherapi/calculationinterval',
      token: localStorage.getItem('token'),
      tempDate: formatDate(new Date(), '{yyyy}-{mm}-{dd}'),
      startDate: formatDate(new Date(), '{yyyy}-{mm}-{dd}'),
      endDate: formatDate(new Date(), '{yyyy}-{mm}-{dd}'),
    }
  },
  methods: {
    onValuesChange(picker, values) {
      this.selectedCondition = values[0] + '-' + values[1]
    },
    PickerControl() {
      this.fxPopupVisible = !this.fxPopupVisible
    },
    CalculationInterval() {
      let that = this
      if (that.startDate === null || that.startDate === '' || that.endDate === null || that.endDate === '') {
        that.$messagebox.alert("请选择时间")
        return
      }
      that.$ajax({
        method: 'get',
        url: that.calculationintervalUrl,
        params: {
          start: that.startDate,
          end: that.endDate,
          startType: that.interval_startDateType,
          endType: that.interval_endDateType,
        },
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              that.$messagebox.alert(response.data['responseData'], '计算结果')
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    CalculationDate() {
      let that = this
      if (that.selectedValue === null || that.selectedValue === '' || that.tempDate === null || that.tempDate === '') {
        that.$messagebox.alert("请输入参数值")
        return
      }
      that.$ajax({
        method: 'get',
        url: that.calculatedateUrl,
        params: {
          date: that.tempDate,
          condition: that.selectedCondition,
          value: that.selectedValue,
          startType: that.date_startDateType,
        },
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              that.$messagebox.alert(response.data['responseData'], '计算结果')
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.rootDiv {
  .mint-navbar .mint-tab-item.is-selected {
    margin-bottom: 0;
  }
}

.title {
  font-size: 1.2rem;
  color: green;
}

.popupClass {
  width: 100%;
  padding-top: 1rem;

  span {
    color: #2986de;
    font-size: 1rem;
  }
}

.buttondiv1 {
  width: 50%;
  float: left;
}

.buttondiv2 {
  width: 50%;
  float: left;
}

.pickerdiv {
  clear: both;
}

.line {
  width: 100%;
  border-top: solid gray 0.5px;
  margin-top: 1.8rem;
}

/deep/ .mint-field-core {
  background-color: transparent;
}
</style>
